module.exports = __webpack_public_path__ + "assets/images/project/japanese-cemetery/02.jpg?v=dbacc7a2";